export default __webpack_public_path__ + "static/media/ShoppingImage.8ba83dcf.svg";